<template>
  <div class="flexbox loginfootercontainer">
    <div class="flexbox linkcontainer">
      <router-link to="/w/info/about-us">
        <div class="link">{{ $t("loginfooter.about") }}</div>
      </router-link>
      |
      <router-link to="/w/info/terms-of-use">
        <div class="link">{{ $t("loginfooter.terms") }}</div>
      </router-link>
      |
      <router-link to="/w/info/privacy-policy">
        <div class="link">{{ $t("loginfooter.privacy") }}</div>
      </router-link>
      |
      <router-link to="/w/info/refund">
        <div class="link">{{ $t("loginfooter.refund") }}</div>
      </router-link>
      |
      <router-link to="/w/info/help-center">
        <div class="link">{{ $t("loginfooter.help") }}</div>
      </router-link>
      |
      <router-link to="/w/info/contact-us">
        <div class="link">{{ $t("loginfooter.contact") }}</div>
      </router-link>
    </div>
    <div class="payimage">
      <img src="~@/assets/images/icepay-logo.png" />
    </div>

    <div class="flexbox website">
      <p>
        Copyright ©{{ new Date().getFullYear() }}
        {{ copy_right_company }}
        All Rights Reserved.
      </p>
    </div>
  </div>
</template>

<script>
import { websiteurl } from "../../common/project.config"
export default {
  data () {
    return {
      websiteurl,
      copy_right_company: 'kissmevv',
    }
  }
}
</script>

<style lang="scss" scoped>
.loginfootercontainer {
  width: 100%;
  height: 150px;

  .linkcontainer {
    width: 100%;
    font-size: 16px;
    color: $themeColor;
    .link {
      color: $linkColor;
      padding: 0 8px;
    }
    .link:hover {
      text-decoration: underline;
    }
  }
  .payimage {
    width: 134px;
    margin-top: 20px;
    img {
      width: 134px;
      height: auto;
    }
  }
  .website {
    width: 100%;
    font-size: 12px;
    color: #fff;
  }
}
</style>